import styled from 'styled-components';
import { FlexCrate, Grid, Crate, Modal } from '@perch-labs/shrike';
import SVG from 'react-inlinesvg';

export const SubNav = styled.nav`
  border-bottom: 1px solid ${props => props.theme.colors.background.tertiary};
  height: 64px;
`;

export const StyledModal = styled(Modal)`
  > div {
    ${props => props.theme.media.xsmall`
      align-self: end;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    `}
  }
`;

export const Content = styled(FlexCrate).attrs({
  backgroundColor: 'primary',
  flex: '1 1 auto',
  flexDirection: 'column',
})``;

export const Wrapper = styled(FlexCrate).attrs({
  flexDirection: 'column',
  height: '100%',
})``;

export const StyledSVG = styled(SVG).attrs(props => ({
  width: props.width || '24px',
  height: props.width || '24px',
  'aria-hidden': true,
}))<StyleProps>`
  margin: ${props => props.margin || '0px'};
`;

export const StyledGrid = styled(Grid)<StyleProps>`
  ${props =>
    props.mobileFullWidth &&
    `
    @media (max-width: ${props.theme.breakpoints.tabletPortrait}px) {
      > div {
        padding-left: 0;
        padding-right: 0;
      }
    }`}
`;

export const StyledCrate = styled(Crate)<StyleProps>`
  @media (max-width: ${props => props.theme.breakpoints.tabletPortrait}px) {
    padding-left: ${props => props.paddingLeftMobile || '24px'};
    padding-right: ${props => props.paddingRightMobile || '24px'};
  }
`;

export const PaymentCard = styled.div`
  border: 1px solid ${props => props.theme.colors.background.tertiary};
  border-radius: ${props => props.theme.borderRadii.large};
  width: 100%;
  padding: 16px;
`;
